import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from '../_service/utility';

@Pipe({ name: 'chineseCounter' })
export class ChineseCouterPipe implements PipeTransform {
    transform(value: number): string {
        let result = value ? value.toString() : '0';
        if(value > 99999999)
        {
            const newValue = Math.round(value / 10000000) / 10;
            if (!(newValue.toString().indexOf('.') !== -1)) {
                result = newValue.toString() + '.0亿';
            } else {
                result = newValue.toString() + '亿';
            }
        }
        else if (value > 9999) {
            result = (value / 10000).toFixed(1) + '万'
            // const newValue = Math.round(value / 1000) / 10;
            // if (!(newValue.toString().indexOf('.') !== -1)) {
            //     result = newValue.toString() + '.0万';
            // } else {
            //     result = newValue.toString() + '万';
            // }
        }
        return result;
    }
    subStr(str: string, length = 8): string {
        return str ? str.substring(0, length) : str;
    }
}


@Pipe({ name: 'safeResource' })
export class SafeResourcePipe implements PipeTransform
{
    constructor(private _utility:Utility)
    {
        
    }
    transform(data,relaceShort= false):string
    {
       let result = this._utility.GetSafeResource(data);
        if(relaceShort)
        {
            return result.replace("s.",".")
        }
       return result;
    }
}
